module.exports = __webpack_public_path__ + "static/media/project_photo@2x.e2172eaa.jpg";